import React from "react";
import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Overline = ({ children, className = "" }) => (
  <span
    className={`inline-block text-[11px] font-sans-body uppercase tracking-[0.28em] text-matcha/80 ${className}`}
  >
    {children}
  </span>
);

export const SerifHeading = ({ children, className = "", as: Tag = "h2" }) => (
  <Tag
    className={`font-serif-display font-light text-ink leading-[1.02] tracking-tight ${className}`}
  >
    {children}
  </Tag>
);

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    className={className}
  >
    {children}
  </motion.div>
);

/* Masked line-by-line reveal — each line slides up from behind a clip */
export const RevealLines = ({ lines, delay = 0, stagger = 0.12, className = "" }) => (
  <span className={`block ${className}`}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className="block"
          initial={{ y: "110%", opacity: 0 }}
          animate={{ y: "0%", opacity: 1 }}
          transition={{ duration: 1.1, ease: EASE, delay: delay + i * stagger }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
